import { create } from 'fedops-logger';

function fedopsLoggerFactory(appName) {
  let fedopsLogger;

  const createLogger = () => fedopsLogger = create(appName);
  const getLogger = () => fedopsLogger ? fedopsLogger : createLogger();

  return {
    getLogger,
  };
}

export default fedopsLoggerFactory;



// WEBPACK FOOTER //
// ./app/services/create-fedops-logger-factory.js